import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import LinkBase from 'components/LinkBase'

export default function Button({
  className, full, level, to, type, ...others
}: props) {
  const componentClassNames = classNames(
    'Button',
    'uk-button',
    full && 'uk-width-1-1',
    level === 'primary' && 'uk-button-default',
    level === 'text' && 'uk-button-text',
    className,
  )

  if (to) {
    return (
      <LinkBase {...others} to={to} className={componentClassNames} />
    )
  }

  return (
    <button {...others} type={type} className={componentClassNames} />
  )
}

Button.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  full: PropTypes.bool,
  href: PropTypes.string,
  level: PropTypes.oneOf(['primary', 'text']),
  to: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit']),
}

Button.defaultProps = {
  level: 'primary',
  type: 'button',
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js